import styles from './index.module.scss';

const LoadingCard = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
      <div className={styles['loadingIcon']} />
      <div className={styles['loadingName']} />
    </div>
  );
};

export default LoadingCard;
